<template>
  <div>Aside</div>
</template>

<script>
export default {
  name: 'DefaultAside'
}
</script>
